export class QuestionComments {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get question() {
        return this.parent;
    }
    get hasComment() {
        return this.question.ownAspect.comment.aspectContent.local.hasContent;
    }
    get hasCommentCorrect() {
        return this.question.ownAspect.commentCorrect.aspectContent.local.hasContent;
    }
    get hasCommentWrong() {
        return this.question.ownAspect.commentWrong.aspectContent.local.hasContent;
    }
    get shouldShowComment() {
        if (!this.hasComment)
            return false;
        if (this.hasCommentCorrect)
            return false;
        if (this.hasCommentWrong)
            return false;
        if (this.question.context.app.appInfo.isUserCurrentlyEditing)
            return true;
        if (this.question.answeringState.isCompletlyAnswered)
            return true;
        return false;
    }
    get shouldShowCommentCorrect() {
        if (!this.hasCommentCorrect)
            return false;
        if (this.question.context.app.appInfo.isUserCurrentlyEditing)
            return true;
        if (this.question.answeringState.isCompletlyAnswered)
            return true;
        return false;
    }
    get shouldShowCommentWrong() {
        if (!this.hasCommentWrong)
            return false;
        if (this.question.context.app.appInfo.isUserCurrentlyEditing)
            return true;
        if (this.question.answeringState.isCompletlyAnswered)
            return true;
        return false;
    }
}
